var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactFormBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1432,
    height: 613,
    viewBox: "0 0 1432 613",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_500_1582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2110.26 -55.8086C1748.46 -1.0797 1181.23 109.678 1469.8 459.311C1837.03 904.245 2734.42 787.685 2335.86 1131.1",
    stroke: "url(#paint0_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1982.69 -77.0127C1620.9 -22.2838 1053.67 88.4738 1342.24 438.107C1709.46 883.041 2606.85 766.481 2208.29 1109.89",
    stroke: "url(#paint1_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855.19 -98.5713C1493.39 -43.8424 926.162 66.9152 1214.73 416.549C1581.96 861.482 2479.35 744.922 2080.79 1088.34",
    stroke: "url(#paint2_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.52 -119.167C1365.73 -64.4381 798.499 46.3195 1087.07 395.953C1454.3 840.886 2351.68 724.326 1953.12 1067.74",
    stroke: "url(#paint3_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1599.56 -137.832C1237.77 -83.1031 670.537 27.6544 959.108 377.288C1326.33 822.221 2223.72 705.661 1825.16 1049.07",
    stroke: "url(#paint4_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471.25 -153.878C1109.45 -99.149 542.222 11.6085 830.793 361.242C1198.02 806.175 2095.41 689.615 1696.85 1033.03",
    stroke: "url(#paint5_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.58 -166.839C980.787 -112.11 413.559 -1.3524 702.129 348.281C1069.36 793.214 1966.74 676.654 1568.18 1020.07",
    stroke: "url(#paint6_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.83 -176.538C851.031 -121.809 283.803 -11.0516 572.374 338.582C939.6 783.515 1836.99 666.955 1438.43 1010.37",
    stroke: "url(#paint7_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.73 -184.004C721.933 -129.275 154.704 -18.5174 443.275 331.116C810.502 776.049 1707.89 659.489 1309.33 1002.9",
    stroke: "url(#paint8_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.536 -189.604C592.74 -134.876 25.5113 -24.118 314.082 325.516C681.309 770.449 1578.7 653.889 1180.14 997.302",
    stroke: "url(#paint9_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.267 -193.084C463.471 -138.355 -103.757 -27.5975 184.813 322.036C552.04 766.969 1449.43 650.409 1050.87 993.823",
    stroke: "url(#paint10_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.957 -194.121C334.161 -139.392 -233.067 -28.6346 55.5034 320.999C422.73 765.932 1320.12 649.372 921.557 992.786",
    stroke: "url(#paint11_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.655 -192.308C204.859 -137.579 -362.37 -26.8211 -73.7988 322.812C293.428 767.746 1190.81 651.186 792.255 994.599",
    stroke: "url(#paint12_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.445 -187.103C75.6491 -132.374 -491.58 -21.6161 -203.009 328.017C164.218 772.951 1061.6 656.391 663.045 999.804",
    stroke: "url(#paint13_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.466 -177.779C-53.3296 -123.05 -620.558 -12.2928 -331.988 337.341C35.2391 782.274 932.626 665.714 534.066 1009.13",
    stroke: "url(#paint14_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.961 -163.314C-181.835 -108.586 -749.063 2.17202 -460.492 351.806C-93.2657 796.739 804.121 680.179 405.561 1023.59",
    stroke: "url(#paint15_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.369 -142.232C-309.427 -87.5035 -876.655 23.254 -588.084 372.888C-220.858 817.821 676.529 701.261 277.969 1044.67",
    stroke: "url(#paint16_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73.4284 -112.426C-435.224 -57.6969 -1002.45 53.0607 -713.882 402.694C-346.655 847.628 550.732 731.068 152.172 1074.48",
    stroke: "url(#paint17_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-195.54 -72.667C-557.336 -17.9381 -1124.56 92.8195 -835.994 442.453C-468.767 887.386 428.619 770.826 30.0596 1114.24",
    stroke: "url(#paint18_radial_500_1582)",
    strokeOpacity: 0.2,
    strokeWidth: 8.2894
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1913.27 537.645) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1785.71 516.441) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1658.2 494.882) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1530.54 474.286) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1402.58 455.621) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1274.26 439.575) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1145.6 426.614) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1015.84 416.915) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(886.743 409.449) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(757.55 403.849) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(628.281 400.369) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(498.971 399.332) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(369.669 401.146) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.459 406.351) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.48 415.674) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-17.0248 430.139) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-144.617 451.221) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-270.414 481.028) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_500_1582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-392.526 520.786) rotate(90) scale(593.453 522.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA9A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_500_1582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1432,
    height: 918,
    fill: "white",
    transform: "translate(0 -305)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactFormBg);
export default __webpack_public_path__ + "static/media/contact-form-bg.67a5fe2633ce3fca4f0787e57f1cb8e8.svg";
export { ForwardRef as ReactComponent };